import { Routes } from '@angular/router';
import { AUTH_ROUTES, APP_ROUTES } from '@core/constants';

export const routes: Routes = [
  // Default route - redirect to login
  {
    path: '',
    redirectTo: AUTH_ROUTES.LOGIN,
    pathMatch: 'full',
  },

  // Auth routes with AuthLayout
  {
    path: 'auth',
    loadComponent: () =>
      import('./shared/layouts/auth-layout/auth-layout.component').then(
        (m) => m.AuthLayoutComponent,
      ),
    children: [
      {
        path: '',
        loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
      },
    ],
    title: 'Authentication - RIB Platform',
  },

  // Onboarding routes (standalone layout - no main layout)
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./features/onboarding/onboarding.routes').then((m) => m.ONBOARDING_ROUTES),
    title: 'Account Opening - RIB Platform',
  },

  // Main application routes with MainLayout
  {
    path: '',
    loadComponent: () =>
      import('./shared/layouts/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent,
      ),
    children: [
      // Dashboard - Lazy loaded
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
        title: 'Dashboard - RIB Platform',
      },

      // Beneficiaries - Lazy loaded
      {
        path: 'beneficiaries',
        data: { breadcrumb: 'Beneficiaries', breadcrumbIcon: 'document' },
        loadChildren: () =>
          import('./features/beneficiaries/beneficiaries.routes').then(
            (m) => m.BENEFICIARIES_ROUTES,
          ),
        title: 'Beneficiaries - RIB Platform',
      },

      // Transactions - Lazy loaded (new route)
      {
        path: 'transactions',
        data: { breadcrumb: 'Transactions', breadcrumbIcon: 'card' },
        loadChildren: () =>
          import('./features/transactions/transactions.routes').then((m) => m.transactionsRoutes),
        title: 'Transactions - RIB Platform',
      },

      // Payments - Lazy loaded (legacy route - kept for backward compatibility)
      {
        path: 'payments',
        loadChildren: () =>
          import('./features/payments/payments.routes').then((m) => m.PAYMENTS_ROUTES),
        title: 'Payments - RIB Platform',
      },

      // Bill Payment - Lazy loaded
      {
        path: 'bill-payment',
        loadChildren: () =>
          import('./features/bill-payment/bill-payment.routes').then((m) => m.BILL_PAYMENT_ROUTES),
        title: 'Bill Payments - RIB Platform',
      },

      // Settings - Lazy loaded
      {
        path: 'settings',
        data: { breadcrumb: 'Settings', breadcrumbIcon: 'settings' },
        loadChildren: () =>
          import('./features/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
        title: 'Settings - RIB Platform',
      },

      // Loans & Credit - Lazy loaded
      {
        path: 'loans-credit',
        data: { breadcrumb: 'Loans & Credit', breadcrumbIcon: 'money' },
        loadChildren: () => import('./features/loans/loans.routes').then((m) => m.LOANS_ROUTES),
        title: 'Loans & Credit - RIB Platform',
      },
      // Reports - Lazy loaded
      {
        path: 'reports',
        data: { breadcrumb: 'Reports', breadcrumbIcon: 'document' },
        loadChildren: () =>
          import('./features/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
        title: 'Reports & Statements - RIB Platform',
      },

      // Cards - Lazy loaded
      {
        path: 'cards',
        data: { breadcrumb: 'Cards', breadcrumbIcon: 'creditCard' },
        loadChildren: () => import('./features/cards/cards.routes').then((m) => m.CARDS_ROUTES),
        title: 'My Cards - RIB Platform',
      },

      // Loyalty & Rewards - Lazy loaded
      {
        path: 'loyalty',
        data: { breadcrumb: 'Loyalty & Rewards', breadcrumbIcon: 'star' },
        loadChildren: () =>
          import('./features/loyalty/loyalty.routes').then((m) => m.LOYALTY_ROUTES),
        title: 'Loyalty & Rewards - RIB Platform',
      },

      // Investments - Lazy loaded
      {
        path: 'investments',
        data: { breadcrumb: 'Investments', breadcrumbIcon: 'bar-chart' },
        loadChildren: () =>
          import('./features/investments/investments.routes').then((m) => m.INVESTMENTS_ROUTES),
        title: 'Investments - RIB Platform',
      },

      // Personal Finance - Lazy loaded
      {
        path: 'personal-finance',
        data: { breadcrumb: 'Personal Finance', breadcrumbIcon: 'chart' },
        loadChildren: () =>
          import('./features/personal-finance/personal-finance.routes').then(
            (m) => m.PERSONAL_FINANCE_ROUTES,
          ),
        title: 'Personal Finance - RIB Platform',
      },

      // 404 Not Found
      {
        path: '404',
        loadComponent: () =>
          import('./shared/components/not-found/not-found.component').then(
            (m) => m.NotFoundComponent,
          ),
        title: '404 Not Found - RIB Platform',
      },
    ],
  },

  // Wildcard route - redirect to 404
  {
    path: '**',
    redirectTo: APP_ROUTES.NOT_FOUND,
  },
];
